// import chatBubble from '../../../images/chatBubble.png';
import okIcon from '../../../images/okIcon.png';

function ProfessionalOffer() {

  const offerList =   ["Creation de materiel", "Maintenance Curative", "Maintenance Préventive"];

  return (
    <div className="bg-white rounded-3xl h-min text-xl shadow-xl w-1/2 m10:w-full m10:max-w-full p-8 mr-6 m10:mr-0">
      <div className="flex flex-row m8:flex-col m8:items-center m8:gap-10">
        <div className="flex flex-col w-3/5 m8:w-full m8:items-center">
          <span className="font-bold text-3xl">
            Gratuite
          </span>
          <span className="mt-4 m8:text-center h-20 m10:h-auto flex flex-row items-center">
            Utilisez Snow GMAO gratuitement avec des fonctionnalités de base
          </span>
        </div>
        {/* <div className="flex flex-col w-2/5 m8:w-full justify-center items-center ">
          <span className="text-5xl font-bold">
            39.99€
          </span>
          <span className="text-lg opacity-70">
            /mois
          </span>
        </div> */}
      </div>
      <div className="flex flex-col mt-10 pl-8 m8:pl-0 m8:items-center">
        <span className="font-bold">
          Incluant:
        </span>
        <div className="flex flex-col pl-4 m8:pl-0">
          {offerList.map((item) => {
            return (
              <div className="flex flex-row items-center mt-4">
                <img className="h-5 pr-4" src={okIcon} alt="okIcon" />
                <span className="opacity-70">
                  {item}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}


function CustomizableOffer() {

  const offerList = ["Creation de materiel", "Maintenance Curative", "Maintenance Préventive", "Messagerie", "Systeme de stockage de documents jusqu'à 30Gb", "Lecture de relevés automatique grâce à l'IA", "Statistiques avancées"];

  return (
    <div className="bg-white rounded-3xl h-min text-xl shadow-xl w-1/2 m10:w-full m10:max-w-full p-8 ml-6 m10:ml-0">
      <div className="flex flex-row m8:flex-col m8:items-center m8:gap-10">
        <div className="flex flex-col w-2/3 m8:w-full m8:items-center">
          <span className="font-bold text-3xl">
          Professionnel
          </span>
          <span className="mt-4 m8:text-center h-20 m10:h-auto">
          Optez pour l'application complète de Snow GMAO
            
          </span>
        </div>

        {/* <div className="flex flex-col w-1/3 m8:w-full justify-center">
          <a href="#contact" className="flex flex-col w-full items-center" >
            <img className="w-28 m8:w-40" src={chatBubble} alt='chatBubble' />
            <span className="text-lg opacity-70">
              contactez-nous
            </span>
          </a>
        </div> */}
      </div>
      <div className="flex flex-col mt-10 pl-8 m8:pl-0 m8:items-center">
        <span className="font-bold">
          Incluant:
        </span>
        <div className="flex flex-col pl-4 m8:pl-0 m8:items-center">
          {offerList.map((item) => {
            return (
              <div className="flex flex-row items-center mt-4">
                <img className="h-5 pr-4" src={okIcon} alt="okIcon" />
                <span className="opacity-70">
                  {item}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}







function Landing() {
  return (
    <div className="flex flex-col items-center justify-center m10:h-auto bg-pricingLanding m10:bg-homeLanding bg-2000 m10:bg-cover bg-repeat-x bg-top w-full overflow-x-hidden">
      <div className="flex mt-52 m10:mt-32 flex-row justify-between mb-40 max-w-7xl px-10 m6:px-5 w-full text-primary m10:flex-col m10:gap-20 m10:items-center">
        <ProfessionalOffer />
        <CustomizableOffer />
      </div>
    </div>);
}

export default Landing;